import { VisitFinishNotApprovedCommand } from '@dreryk/egabinet-visit-frontend-api';

import { Button, ButtonVariant, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import {
   visitActionBarTranslationKeys,
   visitDetailsTranslationKeys,
   visitTranslationKeys,
} from '../../../../translations';
import { useVisitPushBack } from '../../visitForm.hooks';
import { VisitFormDraftSubmitHandler } from '../../visitForm.types';
import { useVisitCommand } from '../shared/confirmVisit.hooks';

import { withConfirmVisitLaterActionInterceptors } from './ConfirmVisitLaterAction.interceptors';

export type ConfirmVisitLaterActionProps = {
   handleSubmitDraft: VisitFormDraftSubmitHandler;
   waiting: boolean;
   visitId: number;
};

export const ConfirmVisitLaterAction = withConfirmVisitLaterActionInterceptors((props) => {
   const pushBack = useVisitPushBack();
   const { executeAsync: executeVisitCommand } = useVisitCommand(VisitFinishNotApprovedCommand, {
      visitId: props.visitId,
      onSuccess: () => {
         dispatchSnackbarPositiveEvent(visitDetailsTranslationKeys.visitSaved);
         pushBack();
      },
   });

   return (
      <Button
         testId={'confirmVisitLater'}
         label={visitActionBarTranslationKeys.confirmLater}
         variant={ButtonVariant.SECONDARY}
         onClick={props.handleSubmitDraft(executeVisitCommand)}
         blockingOperation={visitTranslationKeys.savingVisit}
         disabled={props.waiting}
         compact
         nowrap
      />
   );
});
